import { MANAGE_WORKFLOWS_URL } from './../../constants/constant';
import { Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CoreService } from 'src/app/core/services/core.service';
import { ManageUsersService } from 'src/app/modules/manage-users/services/manage-users.service';
import { DASHBOARD_URL } from '../../constants/constant';
import { Dropdown } from '../../models/dropdown.model';
import { NotificationAlert } from '../../models/notificationAlert.model';
import { UserAffiliationDetails } from '../../models/userDetail.model';
import { TableGridHeader } from '../table-grid/table-grid.model';

@Component({
  selector: 'app-view-affiliation',
  templateUrl: './view-affiliation.component.html',
  styleUrls: ['./view-affiliation.component.scss']
})
export class ViewAffiliationComponent implements OnInit {

  public affiliationForm: FormGroup;
  public submittedAffiliationForm = false;
  public affiliations = [];
  public affiliationsHeaders: TableGridHeader[];
  public selectedAffiliationData: UserAffiliationDetails;
  public professionalBodyOptions: Dropdown[];
  public membershipCategoryOptions: Dropdown[];
  public alert: NotificationAlert;
  public selectedStatus: string;
  public popupMessage: string;
  public selectedDelAffiliation;
  public showDeletePopup = false;
  public loginID: number;
  showBackCPQPNavigationButton: boolean;

  constructor(private coreService: CoreService,
              private manageUsersService: ManageUsersService,
              private route: ActivatedRoute,
              private router: Router
              ) {
                if(this.route && this.route.parent) {
                  this.route.parent.params.subscribe(params => {
                    this.loginID = params.id;
                  });
                }
                if(this.router.url.includes(MANAGE_WORKFLOWS_URL)) {
                  this.showBackCPQPNavigationButton = true;
                }
               }


  ngOnInit(): void {
    this.affiliationsHeaders = [
      {
        name: 'Primary',
        key: 'isPrimaryName',
        sortType: 'string',
        type: 'string'
      },
      {
        name: 'Professional body',
        key: 'professionalBodyCodeName',
        sortType: 'string',
      },
      {
        name: 'Membership category',
        key: 'membershipCategoryCodeName',
        sortType: 'string',
      },
      { name: 'Membership number', key: 'membershipNumber', sortType: 'number' },
      {
        name: 'Membership expiry date',
        key: 'expiryDate',
        sortType: 'date',
        type: 'date',
      }
    ];
    this.getAffiliations();
  }

  private getAffiliations(): void {
    this.manageUsersService.getAffiliationData(this.loginID).subscribe((response) => {
      this.affiliations = response;
      if (this.affiliations.length) {
        this.manageUsersService.updateUserProfileUpdateStr.next(this.affiliations[0]);
      } else {
        this.manageUsersService.updateUserProfileUpdateStr.next(null);
      }
    });
  }

  public onBackToWorkFlow(): void {
    if(this.router.url) {
      this.router.navigateByUrl(this.router.url.substr(1, this.router.url.indexOf('/user')).slice(0, -1));
    }
  }

}
